import { render } from "./DashboardViewGiftCards.vue?vue&type=template&id=5d2810c8&scoped=true"
import script from "./DashboardViewGiftCards.vue?vue&type=script&lang=js"
export * from "./DashboardViewGiftCards.vue?vue&type=script&lang=js"

import "./DashboardViewGiftCards.vue?vue&type=style&index=0&id=5d2810c8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d2810c8"]])

export default __exports__